import styled from '@emotion/styled';
import { Button, Typography } from '@mgmresorts/mgm-ui';

export const StyledMailIcon = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  color: ${({ theme }) => theme.semantic.FgDefault};
  height: ${({ theme }) => theme.semantic.SpaceComponentXl}px;
`;

export const StyledHeading = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
`;

export const StyledDescription = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgContrast};
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentXl}px;
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentS}px;
`;

export const StyledEmailDescription = styled(Typography)`
  text-align: center;
`;

export const StyledButton = styled(Button)`
  color: ${({ theme }) => theme.semantic.FgOnColor};
  font-size: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  padding-left: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  padding-right: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  background: linear-gradient(225deg, #373ae5 0%, #292cb7 50%);
  display: inline-flex;
`;
export const StyledSecondaryButton = styled(Button)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  font-size: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  padding-left: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  padding-right: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  background: transparent;
  border: 1px solid ${({ theme }) => theme.semantic.FgDefault};
  display: inline-flex;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentS}px;
`;

export const StyledResendText = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgContrast};
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentXl}px;
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentM}px;
`;

export const StyledAlertContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.semantic.SpaceLayoutXxl}px;
`;
